import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import {
  ActivityType,
  ActivityOperation,
  ActivitiesService,
  ActivityDetail,
} from "../activities.service";
import { UserService } from "../users/user.service";
import { PoiService } from "../poi/poi.service";
import { TranslateService } from "../translate.service";
@Component({
  selector: "app-dynamic-form",
  templateUrl: "./dynamic-form.component.html",
  styleUrls: ["./dynamic-form.component.css"],
})
export class DynamicFormComponent implements OnInit, OnChanges {
  @Input() formObject;
  @Input() dataObject;
  @Input() dataObjectUpdates;
  @Input() qrcode;
  @Input() idObject;
  @Input() files;
  @Input() action: string;
  @Input() mode: string;
  @Output() onSubmit: EventEmitter<Object> = new EventEmitter();
  @Output() onDelete: EventEmitter<Object> = new EventEmitter();
  @Output() onUpload: EventEmitter<Object> = new EventEmitter();
  @Output() onUndo: EventEmitter<Object> = new EventEmitter();
  @Output() onRecenter: EventEmitter<Object> = new EventEmitter();
  @Output() onDeleteFile: EventEmitter<Object> = new EventEmitter();
  @Output() onPropValueChanged: EventEmitter<Object> = new EventEmitter();

  private form: FormGroup;
  private sections;
  private objectProps;
  private objectData;
  private internalIdObject: String;
  private file;
  private currentFileselector = null;
  private user;
  private userPreferencies = [];
  private dataObjectInternalClasses = [];
  private dataObjectInternalMultivalues = [];
  private fieldDefinitionsById = {};
  private initialFormValues = {};

  constructor(
    private userService: UserService,
    private poiService: PoiService,
    private activities: ActivitiesService,
    private translateService: TranslateService,
  ) {
    let self = this;

    self.form = new FormGroup({});

    /*
    self.userService.getCurrentUser().then(user => {
      self.user = user;
      if (self.user && self.user.attributes && self.user.attributes["custom:preferencies"]) {
        let preferencies = JSON.parse(self.user.attributes["custom:preferencies"]);
        Object.keys(preferencies).forEach(key => {
          self.userPreferencies[key] = preferencies[key];
        });
      }
    }).catch(err => {
      console.log(err);
    });
    */
  }

  ngOnChanges(changes) {
    let self = this;
    if (changes.formObject && changes.formObject.currentValue)
      self.generateUIForm(changes.formObject.currentValue);
    if (changes.dataObject && changes.dataObject.currentValue)
      self.setFormData(changes.dataObject.currentValue);
    if (changes.dataObjectUpdates && changes.dataObjectUpdates.currentValue)
      self.setFormData(changes.dataObjectUpdates.currentValue, false);
    if (changes.idObject) self.internalIdObject = changes.idObject.currentValue;
    if (changes.qrcode) self.qrcode = changes.qrcode.currentValue;
    if (changes.files && changes.files.currentValue)
      self.files = changes.files.currentValue;
  }

  private fileselectorSelect(element) {
    this.currentFileselector = element;
  }

  private fileselectorSelected(event) {
    let self = this;
    if (
      self.currentFileselector &&
      event &&
      event.srcElement &&
      event.srcElement.files &&
      event.srcElement.files.length > 0 &&
      event.srcElement.files[0].name
    ) {
      self.form.controls[self.currentFileselector].setValue(
        self.form.controls[self.currentFileselector].value +
          "," +
          event.srcElement.files[0].name,
      );
      self.currentFileselector = null;
    }
  }

  private extractValues(dataObjects, field) {
    return dataObjects.map((a) => a[field]);
  }

  private buildFieldDefinitionsIndex() {
    let self = this;
    self.fieldDefinitionsById = {};
    (self.sections || []).forEach((section) => {
      (section.items || []).forEach((item) => {
        self.fieldDefinitionsById[item.form_item_id] = item;
      });
    });
  }

  private valueToLabel(field, value) {
    const fieldDefinition = this.fieldDefinitionsById[field];
    if (
      !fieldDefinition ||
      !fieldDefinition.options ||
      (fieldDefinition.type !== "select" && fieldDefinition.type !== "radio")
    ) {
      return value;
    }
    const option = fieldDefinition.options.find(
      (opt) => String(opt.value) === String(value),
    );
    return option
      ? this.translateService.data[option.label] || option.label
      : value;
  }

  private extractLabels(dataObjects, field) {
    return dataObjects.map((a) => this.valueToLabel(field, a[field]));
  }
  private checkValues(values) {
    return values.every((v) => v === values[0]);
  }

  private setFormData(data, resetPristine = true) {
    let self = this;
    let values = data ? data : self.dataObject;
    if (!values || Object.keys(values).length === 0) {
      return;
    } else {
      if (typeof values === "object" && !Array.isArray(values)) {
        Object.keys(values).map((key) => {
          try {
            if (self.form.controls[key]) {
              self.form.controls[key].setValue(values[key]);
              self.dataObjectInternalClasses[key] = "multivalues-no";
              self.dataObjectInternalMultivalues[key] = null;
              if (
                (self.user && self.user.type == "Viewers") ||
                self.mode != "edit"
              ) {
                self.form.controls[key].disable();
              }
            }
          } catch (e) {
            console.log(e);
          }
        });
      } else {
        if (values.length <= 1) {
          if (values[0] && typeof values[0] === "object") {
            Object.keys(values[0]).map((key) => {
              try {
                if (self.form.controls[key]) {
                  self.form.controls[key].setValue(values[0][key]);
                  self.dataObjectInternalClasses[key] = "multivalues-no";
                  self.dataObjectInternalMultivalues[key] = null;
                  if (
                    (self.user && self.user.type == "Viewers") ||
                    self.mode != "edit"
                  ) {
                    self.form.controls[key].disable();
                  }
                }
              } catch (e) {
                console.log(e);
              }
            });
          }
        } else {
          Object.keys(values[0]).map((key) => {
            try {
              if (self.form.controls[key]) {
                if (self.checkValues(self.extractValues(values, key))) {
                  self.form.controls[key].setValue(values[0][key]);
                  self.dataObjectInternalClasses[key] = "multivalues-no";
                  self.dataObjectInternalMultivalues[key] = null;
                } else {
                  self.form.controls[key].setValue(null);
                  self.dataObjectInternalClasses[key] = "multivalues-yes";

                  self.dataObjectInternalMultivalues[key] = self
                    .extractLabels(values, key)
                    .join(", ");
                }

                if (
                  (self.user && self.user.type == "Viewers") ||
                  self.mode != "edit"
                ) {
                  self.form.controls[key].disable();
                }
              }
            } catch (e) {
              console.log(e);
            }
          });
        }
      }
    }
    if (resetPristine) {
      self.initialFormValues = Object.assign({}, self.form.value);
      self.form.markAsPristine();
    }
  }

  private isDirtyField(field) {
    if (!this.form || !this.form.controls || !this.form.controls[field])
      return false;
    if (!Object.prototype.hasOwnProperty.call(this.initialFormValues, field))
      return false;
    return this.form.controls[field].value !== this.initialFormValues[field];
  }

  private generateUIForm(data) {
    let self = this;
    var controls = {};
    self.sections = Object.keys(data).map((propExt) => {
      var itemExt = Object.assign({}, { key: propExt }, data[propExt]);
      itemExt.items = Object.keys(data[propExt].items).map((propInt) => {
        var itemInt = Object.assign(
          {},
          { key: propInt },
          data[propExt].items[propInt],
        );
        itemInt.form_item_id = propInt;
        return itemInt;
      });
      return itemExt;
    });
    self.buildFieldDefinitionsIndex();

    for (let section of Object.keys(self.sections)) {
      for (let prop of Object.keys(self.sections[section].items)) {
        controls[self.sections[section].items[prop].form_item_id] =
          new FormControl(
            {
              value: self.sections[section].items[prop].value || "",
              disabled: self.mode != "edit" ? true : false,
            },
            self.mapValidators(self.sections[section].items[prop].validation),
          );
      }
    }

    self.form = new FormGroup(controls);
    self.initialFormValues = Object.assign({}, self.form.value);
    self.form.markAsPristine();
  }

  ngOnInit() {}

  private mapValidators(validators) {
    const formValidators = [];
    if (validators) {
      for (const validation of Object.keys(validators)) {
        if (validation === "required") {
          formValidators.push(Validators.required);
        } else if (validation === "min") {
          formValidators.push(Validators.min(validators[validation]));
        }
      }
    }
    return formValidators;
  }

  private onPropChanged(prop) {
    let self = this;
    self.onPropValueChanged.emit({
      prop: prop,
      value: self.form.controls[prop.key].value,
    });
  }

  private errorCheck(control_id: string, validator: string) {
    /*if (control_id && validator) {
      this.form.controls[control_id].setErrors({ notUnique: true });
    }*/
  }

  private submit(addnew, duplicate) {
    let self = this;
    var dirtyFields = {};

    var values = self.form.value;
    if (!duplicate)
      values.poiID = self.internalIdObject ? self.internalIdObject : null;
    else values.poiID = null;

    Object.keys(self.form.controls).forEach((field) => {
      if (self.isDirtyField(field)) {
        dirtyFields[field] = true;
      }
    });
    values.addnew = addnew;
    values.dirtyFields = dirtyFields;
    self.onSubmit.emit(values);
  }

  private deleteFile(file) {
    let self = this;
    self.onDeleteFile.emit(file ? file : null);
  }

  private delete() {
    let self = this;
    self.onDelete.emit(self.internalIdObject ? self.internalIdObject : null);
  }

  private upload(data) {
    let self = this;
    self.onUpload.emit(data);
  }

  private undo() {
    let self = this;
    self.form.markAsPristine();
    self.onUndo.emit();
  }

  private recenter() {
    let self = this;
    self.onRecenter.emit();
  }

  private validateDependences(prop) {
    try {
      if (prop && prop.depends_on) {
        let self = this,
          depends_on = prop.depends_on;
        if (prop.hasOwnProperty("depends_on_operator")) {
          switch (prop.depends_on_operator) {
            case "or":
              for (let depend_on of depends_on) {
                if (
                  depend_on.value == self.form.controls[depend_on.item].value
                ) {
                  return true;
                }
              }
              self.form.controls[prop.key].setValue(prop.value);
              return false;
            case "and":
              for (let depend_on of depends_on) {
                if (
                  depend_on.value !== self.form.controls[depend_on.item].value
                ) {
                  self.form.controls[prop.key].setValue(prop.value);
                  return false;
                }
              }
              return true;
          }
        } else {
          for (let depend_on of depends_on) {
            if (depend_on.value !== self.form.controls[depend_on.item].value) {
              self.form.controls[prop.key].setValue(prop.value);
              return false;
            }
          }
          return true;
        }
        return true;
      } else return true;
    } catch (e) {
      console.error("[DYNAMIC FORM validateDependences ERROR]", e);
      console.error("Prop:", prop);
      return true;
    }
  }
}
